/**
 * Shows – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Shows menu icon. */
export default function ShowsIcon({ focused, height, width }: Props) {
  const color = Colors['menu']['icon'][focused ? 'focused' : 'unfocused'];
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || 22 * Screen.widthRatio}
      height={height || 20 * Screen.widthRatio}
      viewBox={'0 0 22 20'}
      fill='none'
    >
      <path
        d='M5.70947 16.8335H15.6258'
        stroke={color}
        strokeWidth={focused ? 3 : 2}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M0.75 12.4045V2.30393C0.75 1.44572 1.63794 0.75 2.73327 0.75H18.5994C19.6948 0.75 20.5827 1.44572 20.5827 2.30393V12.4045C20.5827 13.2627 19.6948 13.9584 18.5994 13.9584H2.73327C1.63794 13.9584 0.75 13.2627 0.75 12.4045Z'
        stroke={color}
        strokeWidth={focused ? 3 : 2}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  );
}
